<template>
  <div class="c-app p-2"
       :class="{ 'c-dark-theme': $store.state.darkMode }">
    <CCard class="w-100 mb-0">
      <CCardHeader class="py-2 d-flex justify-content-between align-items-center">
        <span><BIconColumnsGap class="mr-1"/> <b>경보판</b></span>
        <BButton size="sm" variant="outline-secondary" @click="closeWindow">
          <BIconXLg/> <b>닫기</b>
        </BButton>
      </CCardHeader>
      <CCardBody class="p-2">
        <AlarmBoard list-max-height="70vh" table-min-height="360px"/>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import '@/common/HelperMixin';
import axios from 'axios';
import moment from 'moment';
import qs from 'querystring';
import { apiCall, sleep } from '@/common/utils';
import AlarmBoard from '@/views/components/alarm/AlarmBoard';

export default {
  name: 'AlarmBoardPopup',
  components: { AlarmBoard },
  data () {
    return {
      socket: null,
      tankMap: {},
    }
  },
  computed: {
    alerts(){
      return this.$store.state.alarm.alerts;
    },
  },
  async created(){
    try{
      // 팝업 창은 별도 앱 인스턴스라 부모 창이 넘겨준 인증정보로 로그인 상태를 만든다
      // (MonitorMain/Dashboard 의 모니터 팝업과 같은 방식)
      if( !window.storedUser ){
        alert("[WARN] 인증 정보 없음. 재접속 요망");
        window.close();
        return;
      }

      const storedUser = JSON.parse(window.storedUser);
      axios.defaults.headers.common['x-access-token'] = storedUser.accessToken;
      await this.$store.commit('LOGIN', storedUser);

    }catch(err){
      console.error(err);
      alert(err.message);
      window.close();
    }
  },
  async mounted(){
    try{
      await sleep(1500);
      this.tankMap = this.$store.state.tanks['map'] || {};

      await this.getRecentAlerts();

      this.socket = this.$store.state.socket;
      if(this.socket){
        this.socket.removeListener('event', this.eventAlarmHandler);
        this.socket.on('event', this.eventAlarmHandler);
      }else{
        console.warn('[AlarmBoardPopup] socket not found');
      }

    }catch(err){
      console.error(err);
    }
  },
  beforeDestroy(){
    if(this.socket) this.socket.removeAllListeners('event', this.eventAlarmHandler);
  },
  methods: {
    closeWindow(){
      window.close();
    },

    /** 접속 전에 발생한 경보를 목록에 채운다 (TheAside 와 동일한 API) */
    async getRecentAlerts(){
      try{
        const fromDays = this.$store.state.alarm.count.fromDays || 3;
        const query = qs.stringify({
          fromDts: moment().subtract(fromDays, 'days').toISOString(),
          toDts  : moment().toISOString(),
        });

        const {result} = await apiCall('get', `/api/event/latest?${query}`);
        if(!result) return;

        this.alerts.splice(0, this.alerts.length,
          ...result.map( e => ({...e, tnm: this.tankMap?.[e.tid]?.name || e.tid}) ));

      }catch(err){
        console.error(err);
      }
    },

    /**
     * 소켓 경보 수신 → 목록/건수만 갱신한다.
     * 음성·비프는 본 창(TheAside)이 담당하므로 팝업에서는 울리지 않는다.
     */
    eventAlarmHandler(data){
      const {payload} = data;
      if(!payload?.length) return;

      payload.map( e => {
        this.$store.state.alarm.count[e.code]++;
        this.$store.state.alarm.count['total']++;

        this.alerts.unshift({...e, tnm: this.tankMap?.[e.tid]?.name || e.tnm});
        if(this.alerts.length>100) this.alerts.pop();
      })
    },
  }
}
</script>
